// extracted by mini-css-extract-plugin
export default {"payButton":"cart-breakdown-mobile_payButton__70EFr","amountValue":"cart-breakdown-mobile_amountValue__i2B6N","amountLabel":"cart-breakdown-mobile_amountLabel__8gSdk"};